const vehicles = {
  vehicles: 'רכבים',

  headerButtons: {
    create: {
      createBtn: 'הוסף',
    },

    import: 'ייבא',
  },

  import: {
    title: 'העלאת רכבים',
  },

  toast: {
    error: {
      badResponse: '[רכבים] תגובת שרת שגויה',
      edit: {},
      create: {},
    },
    success: {
      edit: {
        resetSuccess: 'בהצלחה.',
      },
      create: {},
      delete: {
        default: '[רכבים] נמחק בהצלחה',
      },
    },
  },
  table: {
    headers: {
      name: 'שם',
      make: 'יצרן',
      model: 'דגם',
      year: 'שנה',
      color: 'צבע',
      pax: 'מקסימום נוסעים',
      minSeats: 'מינימום נוסעים',
      supplier: 'ספקים',
      attributes: 'מאפיינים',
      service: 'שירות'
    },
    filters: {
      supplier: 'ספקים',
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  deleteModal: {
    header: 'מחק רכבים',
    body: 'אתה עומד למחוק {{num}} רכבים.',
  },

  create: {
    successToast: {
      message: 'הצלחה! הרכב נוצר!',
    },
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן ליצור רכב',
    },
  },

  edit: {
    successToast: {
      message: 'הצלחה! הרכב עודכן!',
    },
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן לעדכן רכב',
    },

    suspendButton: {
      actionActivate: 'בטל השעיה',
      actionDeactivate: 'השעיה',
    },
    suspendModal: {
      popupTitleActive: 'השעיית רכב',
      popupTitleDeactivation: 'בטל השעיית רכב',
      popupTitleUnsuspend: 'סיבת ביטול השעיה',
      popupSubTitleDeactivation: 'בחר את סיבת ההשעיה',
      popupActionActive: 'בטל השעיית רכב',
      popupActionDeactivate: 'השעיית רכב',
    },
    activeStatusButton: {
      statusActive: 'פעיל',
      statusDeactivate: 'לא פעיל',
    },
    formTabs: {
      informationTab: 'מידע',
      notesTab: 'הערות',
      historyTab: 'היסטוריה',
    },
  },

  form: {
    header: {
      createVehicle: {
        title: 'הוסף',
      },

      updateVehicle: {
        title: 'עדכן',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },
    information: {
      details: {
        header: 'מידע כללי',
        fields: {
          name: 'שם',
          site: 'אתר',
          year: 'שנה',
          location: 'מיקום התחלה',
          make: 'יצרן',
          model: 'דגם',
          color: 'צבע',
          suppliers: 'ספקים',
          code: 'מזהה חיצוני',
          vin: 'מספר שלדה',
          productID: 'מזהה מוצר',
          licensePlate: 'מספר רישוי',
          electric: 'חשמלי',
          connectorType: 'סוג מחבר',
          pricePerMinute: 'עלות לדקה',
        },
      },
      attributes: {
        header: 'מאפיינים',
      },
      suppliers: {
        header: 'ספקים',
        fields: {
          suppliers: 'ספקים',
        },
      },
      mileageInspection: {
        header: 'קילומטראז\' ובדיקה',
        fields: {
          mileage: 'קילומטראז\'',
          mileageLastInspection: 'קילומטראז\' בבדיקה האחרונה',
          lastInspectionDate: 'תאריך בדיקה אחרון',
          nextInspectionDate: 'תאריך בדיקה הבא',
        },
      },
      capacity: {
        header: 'קיבולת',
        headerConfigurations: 'תצורות קיבולת',
        fields: {
          seats: 'מקסימום מושבים',
          minSeats: 'מינימום מושבים',
          attribute: 'מאפיין',
          count: 'כמות',
        },
        btnAddConfig: {
          title: 'הוסף תצורה',
        }
      },
      deliveriesDetails: {
        header: 'פרטי משלוחים',
        fields: {
          maxWeight: 'משקל מקסימלי',
          maxVolume: 'נפח מקסימלי'
        },
      },
      services: {
        header: 'שירותים',
      },
      insurance: {
        header: 'ביטוח',
        fields: {
          typeOfInsurance1: 'סוג ביטוח 1',
          typeOfInsurance1_start: 'תאריך התחלה',
          typeOfInsurance1_end: 'תאריך סיום',
          typeOfInsurance2: 'סוג ביטוח 2',
          typeOfInsurance2_start: 'תאריך התחלה',
          typeOfInsurance2_end: 'תאריך סיום',
        },
      },
      dimensions: {
        header: 'מידות הרכב',
      },
      getProductBtn: 'הצג מזהי מוצר של GETT',
      excludedProfiles: {
        header: 'פרופילים מוחרגים',
        dualList: {
          profilesList: {
            header: 'רשימת פרופילים',
          },
          excludedList: {
            header: 'פרופילים שהוחרגו',
          },
        },
      },
    },
    valdations: {
      name: 'שם נדרש',
      plateNumber: {
        matches: 'מקסימום נוסעים חייב להיות מספר',
        required: 'מקסימום נוסעים נדרש',
      },
      service: 'נדרש שירות עם',
      pax: {
        matches: 'מספר נוסעים חייב להיות מספר',
        required: 'נוסעים נדרשים',
      },
      minSeats: {
        matches: 'מינימום מושבים חייב להיות מספר',
        required: 'מינימום מושבים נדרש',
      },
      model: 'נדרש דגם עם',
      color: 'נדרש צבע עם',
      year: {
        matches: 'שנה חייבת להיות מספר',
        required: 'שנה נדרשת',
      },
      licenseExpDate: 'תפוגת רישיון נדרשת',
    },
  },

  statuses: {
    online: 'מקוון',
    suspended: 'מושעה',
    onATrip: 'בנסיעה',
  },

  totalVehicles: 'סה"כ רכבים',
};

export default vehicles;
